<template>
  <nav class="navbar">
    <div class="navbar-container">
      <div class="navbar-top">
        <router-link to="/" class="logo-link">
          <img :src="logoSrc" alt="João Brodt" class="logo-image" />
        </router-link>
        <button class="menu-toggle" @click="toggleMobileMenu" aria-label="Menu">
          <Icon :icon="mobileMenuOpen ? 'material-symbols:close-rounded' : 'material-symbols:menu-rounded'" class="menu-icon" />
        </button>
      </div>
      <div :class="['nav-right', { 'nav-right--mobile-open': mobileMenuOpen }]">
        <ul class="nav-menu">
          <li 
            v-for="category in categories" 
            :key="category.name"
            :class="['nav-item', 'nav-item--desktop', { active: activeCategory === category.name }]"
            @click="setCategory(category.name)"
          >
            <Icon :icon="category.icon" class="icon" />
            {{ category.name }}
          </li>
          <li 
            :class="['nav-item', 'nav-item--desktop', { active: contactActive }]" 
            @click="handleContactClick"
          >
            <Icon icon="material-symbols:chat-rounded" class="icon" />
            CONTATO
          </li>
        </ul>
        <div class="search-container">
          <Icon icon="material-symbols:search-rounded" class="search-icon" />
          <input 
            type="text" 
            placeholder="Buscar" 
            class="search-input"
            v-model="searchQuery"
            @input="handleSearch"
          />
        </div>
      </div>
    </div>
  </nav>
</template>

<script>
import { Icon } from '@iconify/vue';
import logoJoaoBrodt from '../assets/logo_joao_brodt_branco.png';

export default {
  name: 'NavbarMenu',
  components: {
    Icon
  },
  data() {
    return {
      logoSrc: logoJoaoBrodt,
      searchQuery: '',
      mobileMenuOpen: false,
      categories: [
        { name: 'EVENTOS', icon: 'material-symbols:calendar-month-outline-rounded' },
        { name: 'TECNOLOGIA', icon: 'material-symbols:devices-outline-rounded' },
        { name: 'NOTÍCIAS', icon: 'material-symbols:article-outline-rounded' }
      ],
      contactActive: false
    }
  },
  computed: {
    activeCategory() {
      if (this.contactActive) {
        return null;
      }
      const routeMap = {
        '/eventos': 'EVENTOS',
        '/tecnologia': 'TECNOLOGIA',
        '/noticias': 'NOTÍCIAS'
      }
      return routeMap[this.$route.path] || null
    }
  },
  watch: {
    '$route.path'(newPath) {
      if (newPath !== '/buscar') {
        this.searchQuery = '';
      }
      this.contactActive = newPath === '/contato';
    }
  },
  created() {
    this.contactActive = this.$route.path === '/contato';
  },
  methods: {
    setCategory(category) {
      this.contactActive = false;
      this.mobileMenuOpen = false;
      this.$emit('category-change', category);
    },
    handleSearch() {
      this.$emit('search', this.searchQuery);
    },
    handleContactClick() {
      this.contactActive = true;
      this.mobileMenuOpen = false;
      if (this.$route.path !== '/contato') {
        this.$router.push('/contato');
      }
    },
    toggleMobileMenu() {
      this.mobileMenuOpen = !this.mobileMenuOpen;
    }
  }
}
</script>

<style scoped>
.navbar {
  background: var(--brand-navy);
  padding: 0;
  box-shadow: 0 20px 40px rgba(23, 29, 58, 0.35);
  position: sticky;
  top: 0;
  z-index: 1000;
  color: #f5f8ff;
}

.navbar-container {
  max-width: 1400px;
  margin: 0 auto;
  padding: 1rem 0.5rem 1rem 3rem;
  display: flex;
  justify-content: space-between;
  align-items: center;
  gap: 1.5rem;
}

.navbar-top {
  display: flex;
  align-items: center;
  gap: 1rem;
}

.nav-right {
  display: flex;
  align-items: center;
  gap: 2rem;
  margin-left: auto;
  justify-content: flex-end;
}


.search-container {
  position: relative;
  display: flex;
  align-items: center;
  color: rgba(255, 255, 255, 0.85);
}

.search-container--mobile {
  display: none;
}

.search-container--desktop {
  display: flex;
}

.search-icon {
  position: absolute;
  left: 1rem;
  font-size: 19px;
  color: currentColor;
  pointer-events: none;
}

.search-input {
  padding: 0.6rem 1rem 0.6rem 2.8rem;
  border-radius: 28px;
  border: 1px solid rgba(229, 233, 253, 0.6);
  background: rgba(229, 233, 253, 0.2);
  color: #ffffff;
  font-size: 14px;
  outline: none;
  transition: all 0.3s ease;
  width: 200px;
}

.search-input::placeholder {
  color: rgba(255, 255, 255, 0.55);
}

.search-input:focus {
  background: rgba(229, 233, 253, 0.35);
  border-color: rgba(149, 171, 249, 0.9);
  box-shadow: 0 12px 32px rgba(23, 29, 58, 0.35);
  width: 250px;
}

.logo-link {
  text-decoration: none;
  cursor: pointer;
  transition: opacity 0.3s ease;
  display: inline-flex;
  align-items: center;
}

.logo-link:hover {
  opacity: 0.85;
}

.logo-image {
  display: block;
  height: 36px;
  width: auto;
  filter: drop-shadow(0 6px 16px rgba(0, 0, 0, 0.35));
  transition: transform 0.3s ease;
}

.logo-link:hover .logo-image {
  transform: translateY(-1px);
}

.nav-menu {
  display: flex;
  list-style: none;
  margin: 0;
  padding: 0;
  gap: 1.5rem;
}

.nav-item {
  color: rgba(255, 255, 255, 0.9);
  font-weight: 600;
  cursor: pointer;
  padding: 0.5rem 1rem;
  border-radius: 999px;
  transition: all 0.3s ease;
  display: flex;
  align-items: center;
  gap: 0.5rem;
}

.icon {
  font-size: 21px;
  display: inline-flex;
  align-items: center;
  color: inherit;
}

.nav-item:hover {
  background: rgba(229, 233, 253, 0.25);
  transform: translateY(-2px);
}

.nav-item.active {
  background: rgba(229, 233, 253, 0.25);
}

.menu-toggle {
  display: none;
  background: none;
  border: none;
  color: rgba(255, 255, 255, 0.9);
  cursor: pointer;
  padding: 0.5rem;
  border-radius: 8px;
  transition: all 0.3s ease;
  align-items: center;
  justify-content: center;
}

.menu-toggle:hover {
  background: rgba(229, 233, 253, 0.25);
}

.menu-icon {
  font-size: 29px;
}

@media (max-width: 1024px) {
  .navbar-container {
    padding: 1rem 2rem;
  }
  
  .nav-right {
    gap: 1.5rem;
  }
  
  .search-input {
    width: 150px;
  }
  
  .search-input:focus {
    width: 200px;
  }
  
  .nav-menu {
    gap: 1rem;
  }
}

@media (max-width: 768px) {
  .navbar-container {
    flex-direction: column;
    align-items: stretch;
    gap: 0;
    padding: 1rem 2rem;
  }
  
  .navbar-top {
    width: 100%;
    justify-content: space-between;
    gap: 0.8rem;
  }
  
  .logo-image {
    height: 44px;
  }
  
  .logo-link {
    flex-shrink: 0;
  }

  .menu-toggle {
    display: flex;
    flex-shrink: 0;
  }

  .nav-right {
    max-height: 0;
    overflow: hidden;
    opacity: 0;
    transition: all 0.3s ease;
    flex-direction: column;
    width: 100%;
    gap: 0;
  }

  .nav-right--mobile-open {
    max-height: 400px;
    opacity: 1;
    padding-top: 1rem;
  }

  .nav-menu {
    flex-direction: column;
    gap: 0.5rem;
    width: 100%;
    align-items: center;
    order: 2;
  }

  .search-container {
    width: 100%;
    margin-bottom: 1rem;
    order: 1;
  }

  .search-input {
    width: 100%;
  }

  .search-input:focus {
    width: 100%;
  }

  .nav-item {
    width: 100%;
    justify-content: center;
    font-size: 14px;
    padding: 0.7rem 1rem;
  }
}

@media (max-width: 480px) {
  .navbar-container {
    padding: 1rem 2rem;
  }
  
  .logo-image {
    height: 38px;
  }
}
</style>
